import * as React from 'react';

const useIsScrollable = <T extends HTMLElement = HTMLDivElement>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dependencies: any[]
): readonly [boolean, (node: T) => void, T | undefined] => {
  const [node, setNode] = React.useState<T>();
  const ref = React.useCallback((node: T) => {
    setNode(node);
  }, []);

  const [isScrollable, setIsScrollable] = React.useState<boolean>(false);

  React.useLayoutEffect(() => {
    if (!node) return;

    setIsScrollable(node.scrollHeight > node.clientHeight);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...dependencies, node]);

  React.useLayoutEffect(() => {
    if (!node) return;

    const handleWindowResize = () => {
      setIsScrollable(node.scrollHeight > node.clientHeight);
    };

    window.addEventListener('resize', handleWindowResize);

    return () => window.removeEventListener('resize', handleWindowResize);
  }, [node]);

  return [isScrollable, ref, node] as const;
};

export default useIsScrollable;
